import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Avatar } from "@/components/ui/avatar";
import { Input } from "@/components/ui/input";
import { Comment } from "@/types/comment";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

interface CommentsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  comments: Comment[];
  newComment: string;
  onNewCommentChange: (value: string) => void;
  onAddComment: () => void;
}

export function CommentsDialog({
  open,
  onOpenChange,
  comments,
  newComment,
  onNewCommentChange,
  onAddComment
}: CommentsDialogProps) {
  const formatDate = (timestamp: any) => {
    if (!timestamp) return '';
    
    // Handle Firestore Timestamp
    const date = timestamp?.toDate?.() || new Date(timestamp);
    return format(date, "d 'de' MMMM", { locale: ptBR });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Comentários</DialogTitle>
        </DialogHeader>
        <div className="mt-4 space-y-4">
          {/* Comments List */}
          <div className="space-y-4 max-h-[400px] overflow-y-auto">
            {comments.map((comment) => (
              <div key={comment.id} className="flex gap-3">
                <Avatar>
                  <div className="bg-blue-600 w-full h-full flex items-center justify-center text-white">
                    {comment.authorName?.charAt(0).toUpperCase()}
                  </div>
                </Avatar>
                <div className="flex-1">
                  <div className="bg-gray-100 rounded-lg p-3">
                    <div className="flex items-center justify-between mb-1">
                      <span className="font-medium">{comment.authorName}</span>
                      <span className="text-sm text-gray-500">
                        {formatDate(comment.createdAt)}
                      </span>
                    </div>
                    <p className="text-gray-800">{comment.content}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Add Comment */}
          <div className="flex gap-2">
            <Input
              value={newComment}
              onChange={(e) => onNewCommentChange(e.target.value)}
              placeholder="Escreva um comentário..."
              onKeyPress={(e) => e.key === 'Enter' && onAddComment()}
            />
            <Button onClick={onAddComment}>Enviar</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}